import React, { useEffect, useState } from 'react';
import { Select, Spin, message } from 'antd';
import debounce from 'lodash/debounce';
import { Avatar } from '@mui/material';
import rootApi from '@utils/baseAPI/WrapperApi';

const { Option } = Select;

const PartnerSelect = ({ onChange, initValue }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customerSelected, setCustomerSelected] = useState([]);

  const fetchCustomers = async (searchText) => {
    setLoading(true);
    try {
      const response = await rootApi.get(`/admin/partners/search`, {
        params: {
          name: searchText ?? undefined,
          page: 0,
          size: 999
        }
      });
      setCustomers(response.data?.data);
    } catch (error) {
      message.error('Có lỗi khi lấy thông tin đối tác!');
      console.error('Failed to fetch customers', error);
    }
    setLoading(false);
  };

  const handleSearch = debounce((value) => {
    if (value) {
      fetchCustomers(value);
    } else {
      setCustomers([]);
    }
  }, 300);

  const handleChange = (value) => {
    setCustomerSelected(value);
    onChange && onChange(value);
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  useEffect(() => {
    if (initValue && customers.length > 0) {
      const selectedCustomers = initValue
        .map((id) => customers.find((customer) => customer.id === id))
        .filter(Boolean)
        .map((customer) => ({
          value: customer.id,
          label: customer.name ?? customer.short_name
        }));
      setCustomerSelected(selectedCustomers);
    }
  }, [initValue, customers]);

  const renderCustomerOption = (customer) => (
    <Option
      key={customer.id}
      value={customer.id}
      label={`${customer.short_name} - ${customer.name}`}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          alt={customer?.username?.toUpperCase()}
          src={customer.avatar ? customer?.avatar : 'https://'}
          sx={{ bgcolor: '#00904A' }}
          style={{ marginRight: 8 }}
        />
        <div>
          <div style={{ fontSize: '14px', fontWeight: '400', color: '#192434' }}>
            {`${customer.short_name} - ${customer.name}`}
          </div>
          <div style={{ fontSize: '12px', color: '#626D7C', fontWeight: '400' }}>
            {customer.phone_number}
          </div>
        </div>
      </div>
    </Option>
  );

  return (
    <div style={{ width: '100%' }}>
      <Select
        showSearch
        labelInValue
        placeholder="Lựa chọn đối tác"
        onChange={handleChange}
        value={customerSelected}
        notFoundContent={loading ? <Spin size="small" /> : null}
        filterOption={false}
        onSearch={handleSearch}
        style={{ width: '100%', minHeight: '36px' }}
        dropdownStyle={{ maxHeight: '200px', overflowY: 'auto' }}
        optionLabelProp="label">
        {customers.map(renderCustomerOption)}
      </Select>
    </div>
  );
};

export default PartnerSelect;
